import {
	SimpleForm,
	ReferenceInput,
	SelectInput,
	TextInput,
	ImageInput,
	ImageField,
	LongTextInput,
	SelectArrayInput,
	ReferenceArrayInput,
	CheckboxGroupInput,
	TabbedForm,
	FormTab
} from "react-admin";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import React from "react";
import { required } from "../../services/validate";
import { typeRole } from "../../constant/TypeRole";

class UserForm extends React.Component {
	state = {
		roleSelect: this.props.record.role ? this.props.record.role._id : ""
	};
	onCheckbokChange = (event, checked) => {
		const props = this.props;
		if (checked) {
			const permission = Object.keys(props.routes).map(key => key);
			props.changeValueField("permission", permission);
		} else {
			props.changeValueField("permission", []);
		}
	}
	render() {
		const props = this.props;
		const role = localStorage.getItem("role");
		const { roleSelect } = this.state;
		const permission = Object.keys(props.routes)
			.map(key => ({ id: key, name: props.routes[key].props.options.label }))
			.sort((a, b) => a.name.localeCompare(b.name));
		return (
			<TabbedForm {...this.props}>
				<FormTab label="user.tab.user">
					<TextInput disabled={props.isEdit} source="email" validate={[required()]} />
					<TextInput disabled source="provider" defaultValue={!props.isEdit ? "local" : undefined} validate={[required()]} />
					<TextInput source="password" type="password" label={props.isEdit ? "แก้ไขรหัสผ่าน" : undefined} validate={!props.isEdit ? [required()] : undefined} />
					<TextInput source="firstname" validate={[required()]} />
					<TextInput source="lastname" validate={[required()]} />
					<TextInput source="mobile" validate={[required()]} />
				</FormTab>
				{role === "superadmin" && (
					<FormTab label="user.tab.role">
						<SelectInput
							source="role._id"
							choices={typeRole}
							validate={[required()]}
							onChange={(event, key, payload) =>
								this.setState({ roleSelect: key })
							}
						/>
						{roleSelect === "5b167d28e48150001143b2be" ? (
							<ReferenceArrayInput
								source="project"
								reference="project"
								validate={[required()]}
							>
								<SelectArrayInput optionText="name" />
							</ReferenceArrayInput>
						) : null}
						{roleSelect === "5b167d28e48150001143b2be" ? (
							<CheckboxGroupInput source="permission" choices={permission} />
						) : null}

						<FormControlLabel
							control={<Checkbox style={{ color: "#3f51b5" }} onChange={this.onCheckbokChange} />}
							label="เลือกทั้งหมด/ไม่เลือกทั้งหมด"
						/>
					</FormTab>
				)}
			</TabbedForm>
		);
	}
}


export default UserForm;




// WEBPACK FOOTER //
// ./src/components/user/UserForm.js